<template>
  <div class="modal-content">
    <div class="modal-header">
      Figma Preview
    </div>
    <FigmaLayerSelector v-if="currentFile && !currentFile.isFetching" />
    <FigmaSpinnerLoader v-else />
  </div>
</template>

<script>

import FigmaLayerSelector from "@frontend/components/modules/figma-layers/FigmaLayerSelector.vue";
import {FIGMA_LAYERS_EVENTS, figmaLayersEventBroker} from "@frontend/group/modules/fig-layers/event-broker";
import {createNamespacedHelpers} from "vuex";
import FigmaSpinnerLoader from "@frontend/components/modules/figma-layers/FigmaSpinnerLoader";

const { mapGetters, mapActions } = createNamespacedHelpers('figmaLayers')

export default {
  name: 'FigmaPreview',
  components: {FigmaSpinnerLoader, FigmaLayerSelector },
  computed: {
    ...mapGetters(
      ['currentFile']
    ),
  },
  mounted() {
    figmaLayersEventBroker.on(FIGMA_LAYERS_EVENTS.INIT, this.init.bind(this), true);
  },
  methods: {
    ...mapActions(
      ['loadFiles']
    ),
    async init(data) {
      await this.loadFiles(data.files);
    }
  }
}

</script>
